
import { BasePermissionHelper } from 'baseauth';
import { appcontrols } from 'solar-bo';
import { ControlEnum } from 'solar-bo';


export class PermissionHelper extends BasePermissionHelper {


    public static validateResourceACL(resourceId: string, entityId: string,entities_acl:any[]): boolean {
        switch (resourceId) {
            case ControlEnum.BTN_SITE_EDIT:
            case ControlEnum.BTN_SITE_DELETE :
            case ControlEnum.BTN_SUPERVISION_EDIT :    
                if (!entityId) {
                    return false;
                }
                let resourceRoles = PermissionHelper.resourceGetRoles(resourceId);
                if (!resourceRoles) {
                    return false;
                }
                let aclForEntity:any=entities_acl.find(elem=>elem.id==entityId);
                if (aclForEntity){
                    aclForEntity=aclForEntity.acl;
                }
                let canAccess = BasePermissionHelper.checkUserACL(aclForEntity, resourceRoles)
                if (!canAccess) {
                    return false;
                } else {
                    return true;
                }
        }
    }

    public static resourceGetRoles(resourceId:string):string[] {
        let resource = appcontrols.find(elem => elem.resourceId == resourceId);
        return resource.roles;
    }


}